import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

export class GetFormattedNewsTagService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object<Mapper>} deps.fromTagsListToFormattedTagsListNewsValueObjectMapper
   */
  constructor({config, fromTagsListToFormattedTagsListNewsValueObjectMapper}) {
    super()
    this._config = config
    this._fromTagsListToFormattedTagsListNewsValueObjectMapper = fromTagsListToFormattedTagsListNewsValueObjectMapper
  }

  @inlineError
  async execute({tags = []}) {
    return this._fromTagsListToFormattedTagsListNewsValueObjectMapper.setParams({tags}).map()
  }
}
